import { formItemLayout } from "Admin/Config/FormLayout";
import { unit_level_colors } from "Admin/Config/UnitLevel";
import { updateUnitSummary } from "Admin/Service/Unit";
import { handleAPIResponse } from "Admin/Utils/HandleAPIResponse";
import { numberRegex } from "Admin/Utils/numberRegex";
import { Button, Form, Input, message, Tag } from "antd";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import styles from "./Summary.module.scss";

const Summary = ({ summary }) => {
  const [form] = Form.useForm();
  const entity_id = useLocation().pathname.split("/")[3].split("-")[0];
  const entity_type = useLocation().pathname.split("/")[3].split("-")[1];
  const name = Form.useWatch("name", form);
  const level = Form.useWatch("level", form);
  const totalFaculties = Form.useWatch("total_faculties", form);
  const totalPublication = Form.useWatch("total_publication", form);
  const bio = Form.useWatch("bio", form);
  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(summary);
  }, [summary]);
  const onFinishForm = () => {
    const payload = {
      bio: bio,
    };
    updateUnitSummary(entity_id, entity_type, payload, (res) => {
      handleAPIResponse(res, () => {
        message.success("Update unit summary successfully");
      });
    });
  };
  return (
    <div className={styles["unit-summary"]}>
      <Form
        {...formItemLayout}
        form={form}
        onFinish={onFinishForm}
        layout="vertical"
      >
        <Form.Item
          rules={[
            {
              required: true,
            },
          ]}
          label={"Name:"}
          labelAlign="left"
          name="name"
        >
          <p>{name}</p>
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
            },
          ]}
          label={"Level:"}
          labelAlign="left"
          name="level"
        >
          <Tag color={unit_level_colors[level - 1]}>Level {level}</Tag>
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
            },
          ]}
          label={"Total faculty members:"}
          labelAlign="left"
          name="total_faculties"
        >
          <p>{numberRegex(totalFaculties)}</p>
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
            },
          ]}
          label={"Total publications:"}
          labelAlign="left"
          name="total_publication"
        >
          <p>{numberRegex(totalPublication)}</p>
        </Form.Item>
        <Form.Item label={"Biography:"} labelAlign="left" name="bio">
          <Input.TextArea rows={6} placeholder="Please input the biography" />
        </Form.Item>
        <div className={styles["update-button"]}>
          <Button htmlType="submit" type="primary">
            Update
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default Summary;
